import type { BadgeVariant } from '@/components/ui';
import type { TemplateVersionStatus } from '@/api/services/hrDocuments.service';

export const VERSION_STATUS: Record<
  TemplateVersionStatus,
  { label: string; variant: BadgeVariant }
> = {
  draft: { label: 'Draft', variant: 'neutral' },
  pending_approval: { label: 'Awaiting approval', variant: 'warning' },
  approved: { label: 'Approved', variant: 'success' },
  retired: { label: 'Superseded', variant: 'neutral' },
};

/** Saves a downloaded blob under a file name. */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
